// web-payments catalog serving `convert` products that are charged in Diamonds and award
// consumable items. Resolved by the generic `GET /:feature/catalog` route.
export const ITEM_CONVERT_CATALOG = 'item-convert';

/* Feature that convert orders - credits and items alike - are submitted under. web-payments
 * registers order routes as literal paths - `/cash-reward/orders/:orderId` and
 * `/convert/orders/:orderId` - with no generic `/:feature/orders/:orderId`, so an
 * item-specific route would 404. The existing convert route is correct for items too:
 * ClaimRewardService.convertCurrency is product-agnostic, and what gets awarded is decided
 * by the product definition.
 */
export const CONVERT_ORDER_FEATURE = 'convert';

const ClaimRewardsStatuses = Object.freeze({
  idle: 'idle',
  processing: 'processing',
  success: 'success',
  error: 'error',
});

export default ClaimRewardsStatuses;
